import { useState } from 'react';
import { messages } from '@fruitways/shared';
import { ConfirmDialog, Icon } from '@/components';
import { useAuth } from '@/hooks/useAuth';

/** Header action: role label with a chevron; opens the menu with the user's name and Log out. */
export function ProfileMenu({ unsaved = false }: { unsaved?: boolean }) {
  const { user, logout } = useAuth();
  const role = user?.role === 'admin' ? messages.header.profileAdmin : messages.header.profile;
  const roleLine = user?.role === 'admin' ? messages.header.roleAdmin : messages.header.profile;
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fw-reset-button"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          minHeight: '44px',
          padding: '0 6px',
          font: 'var(--type-body-medium)',
          color: 'var(--color-primary)',
        }}
      >
        <span>{role}</span>
        <Icon name="chevron-down" size={18} />
      </button>

      {open && (
        <>
          <div className="fw-scrim" style={{ zIndex: 50 }} onClick={() => setOpen(false)} />
          <div
            style={{
              position: 'absolute',
              top: '56px',
              right: '12px',
              zIndex: 55,
              width: '216px',
              display: 'flex',
              flexDirection: 'column',
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-md)',
              boxShadow: 'var(--shadow-sheet)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                padding: 'var(--space-3) var(--space-4)',
                borderBottom: '1px solid var(--color-border)',
              }}
            >
              <span className="fw-body-medium">{user?.displayName ?? user?.username}</span>
              <span className="fw-secondary">{roleLine}</span>
            </div>
            <button
              type="button"
              className="fw-reset-button"
              onClick={() => {
                setOpen(false);
                setConfirm(true);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                minHeight: '56px',
                padding: '0 var(--space-4)',
                font: 'var(--type-body)',
                color: 'var(--color-danger)',
              }}
            >
              <Icon name="log-out-outline" size={24} />
              {messages.header.logOut}
            </button>
          </div>
        </>
      )}

      <ConfirmDialog
        open={confirm}
        title={unsaved ? messages.dialogs.logOut.unsavedTitle : messages.dialogs.logOut.title}
        body={unsaved ? messages.dialogs.logOut.unsavedBody : messages.dialogs.logOut.body}
        confirmLabel={messages.dialogs.logOut.confirm}
        cancelLabel={messages.common.cancel}
        variant="danger"
        busy={busy}
        onCancel={() => setConfirm(false)}
        onConfirm={async () => {
          setBusy(true);
          await logout();
          setBusy(false);
          setConfirm(false);
        }}
      />
    </>
  );
}
